<template>
<div>老人坐标</div>
</template>

<script>
export default {
  name: 'oldPersonCoordinate'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/oldPersonCoordinate.vue